/** Keep in sync with FroomWasteTracker.Data.VehicleTypes */
export const VEHICLE_TYPES = [
    "Skip lorry",
    "Grab lorry",
    "Tipper",
    "Artic",
    "Rigid",
    "Van",
    "Car / pickup",
    "Trailer",
    "Other",
] as const;

export type VehicleTypeValue = (typeof VEHICLE_TYPES)[number];

const allowedSet = new Set<string>(VEHICLE_TYPES);

/** Null, empty, and whitespace are valid (optional field). */
export function isAllowedVehicleType(value: string | null | undefined): boolean {
    if (value == null || value.trim() === "") return true;
    return allowedSet.has(value.trim());
}
